module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="phx-lanceetat-filter" >\r\n  <div class="form-row">\r\n    <div class="form-group col-12">\r\n      <span class="cboTheme"></span> \r\n    </div>\r\n  </div>\r\n  <div class="form-row">\r\n    <div class="form-group col-12">\r\n      <input type="text" class="libelle form-control" value="" size="28" maxlength="50" placeholder="'+
((__t=(i18n.t('lanceetat.libelle')))==null?'':__t)+
'"/> <br/>\r\n    </div>\r\n  </div>\r\n  \r\n</div>';
}
return __p;
};
